import React from "react";
import { fetchRuneMarketData } from "../utils/api";

const TraderOfTheDay = ({ data, setPopup, showNotification }) => {
  const copyTrade = () => {
    navigator.clipboard.writeText(data.topTrader);
    showNotification(
      `Started copy trading for ${data.topTrader.slice(0, 4)}...${data.topTrader.slice(-4)}`
    );

    window.open(`https://telegram.me/dotswap_trade_bot?start=__${data.topTrader}`, "_blank");
  };

  const handleRuneInfoClick = async (ticker) => {
    const runeData = await fetchRuneMarketData(ticker);
    if (runeData) {
      setPopup({
        type: "runeMarket",
        data: runeData,
      });
    } else {
      showNotification(`Failed to fetch data for ${ticker}`);
    }
  };

  return (
    <div className="lg:w-1/4 bg-gray-700 p-2 sm:p-4 rounded-lg shadow border-2 border-pink-500">
      <h3 className="text-lg sm:text-xl font-bold text-pink-500 mb-2 sm:mb-4 text-center">
        Trader of the Day
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Address</strong>
          <p
            className="text-pink-500 cursor-pointer hover:text-pink-400 text-xs sm:text-sm"
            onClick={async() =>
              {
                await navigator.clipboard.writeText(data.topTrader);
                const shortAddress = `${data.topTrader?.slice(0, 4)}...${data.topTrader?.slice(-4)}`;
                showNotification(`Started copy trading for ${shortAddress}`);
              }
            }
          >
            {data.topTrader?.slice(0, 4)}...{data.topTrader?.slice(-4)}
          </p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Profit %</strong>
          <p
            className={`${
              parseFloat(data.topProfit) >= 0 ? "text-green-400" : "text-red-400"
            } text-xs sm:text-sm`}
          >
            {data.topProfit}%
          </p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Trades</strong>
          <p className="text-xs sm:text-sm">{data.topTrades}</p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Volume</strong>
          <p className="text-xs sm:text-sm">
            {(data.topVolume / Math.pow(10, 8)).toFixed(3)} BTC
          </p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Most Traded</strong>
          <div className="flex items-center justify-center gap-1">
            <p className="text-xs sm:text-sm break-all">{data.topRuneTicker}</p>
            <i
              className="fas fa-info-circle text-pink-500 cursor-pointer hover:text-pink-400"
              onClick={() => handleRuneInfoClick(data.topRuneTicker)}
              title="Rune Market Info"
            />
          </div>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Win Rate</strong>
          <p
            className={`${
              data.topWinRate >= 50 ? "text-green-400" : "text-red-400"
            } text-xs sm:text-sm`}
          >
            {data.topWinRate}%
          </p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Avg Trade Size</strong>
          <p className="text-xs sm:text-sm">{(parseInt(data.topAvgTradeSize) / Math.pow(10, 8)).toFixed(5)} BTC</p>
        </div>
        <div className="bg-gray-800 p-1 sm:p-2 rounded text-center">
          <strong className="text-xs sm:text-sm">Max Drawdown</strong>
          <p className="text-red-400 text-xs sm:text-sm">{Number(data.topMaxDown).toFixed(2)}%</p>
        </div>
        <button
          onClick={copyTrade}
          className="bg-pink-600 hover:bg-pink-700 text-white px-3 py-1 sm:px-4 sm:py-2 rounded-lg mt-2 w-full text-sm sm:text-base col-span-1 sm:col-span-2"
        >
          Copy Trade
        </button>
      </div>
    </div>
  );
};

export default TraderOfTheDay;
